import { connect } from "react-redux";
import _ from "underscore";

var CurrentUser = require("lib/account/CurrentUser");

var RosterSelectors = require("lib/selectors/RosterSelectors");
var WritingSelectors = require("lib/selectors/WritingSelectors");
var WritingActions = require("lib/actions/WritingActions");
var ReactTooltip = require("react-tooltip");
var Glyphicon = require("components/utility/icons/Glyphicon");
var NumbersOnlyInput = require("components/utility/NumbersOnlyInput");

require("writing/evaluations/score_display.scss");

@connect(
	(state, props) => {
		var downProps = {}
		if (props.subjectID && props.subjectType) {
			downProps.evaluation = WritingSelectors.evaluationForSubject({
				state, subjectType: props.subjectType, subjectID: props.subjectID
			});
		} else if (props.evaluationID) {
			downProps.evaluation = WritingSelectors.evaluation({ state, id: props.evaluationID });
		}

		if (downProps.evaluation) {
			if (downProps.evaluation.subject_type == "Answer") {
				var subject = WritingSelectors.answer({ state, id: downProps.evaluation.subject_id })
				downProps.noun = "answer";
			} else if (downProps.evaluation.subject_type == "Quiz") {
				 var subject = WritingSelectors.quiz({ state, id: downProps.evaluation.subject_id })
				downProps.noun = "quiz";
			}
			if (subject) {
				// Would require the answer or quiz to already be loaded into redux state
				downProps.excluded = subject.excluded;				
			}
		}


		if (CurrentUser.isStudent()) {
			var slPrefs = CurrentUser.get().prefs;
			downProps.asStudent = true;
		} else {
			var slPrefs = RosterSelectors.studentListPrefs({ state }) || {};	
			downProps.asStudent = false;		
		}
		downProps.passingThreshold = slPrefs.passing_threshold;
		downProps.displayScoreCap = slPrefs.display_score_cap;

		if(props.answerIDs){
			var answers = _.map(props.answerIDs, answerID=> WritingSelectors.answer({ state, id: answerID }))
			
			downProps.filters = _.some(answers, answer =>{
				if (answer.evaluation){
					var evaluation = WritingSelectors.evaluation({state, id: answer.evaluation})
					if (evaluation.autograder_data && evaluation.autograder_data.filtering && evaluation.autograder_data.filtering.length > 0){
						return true
					}
				}
				else return false
			})

			downProps.warnings = _.some(answers, answer =>{
				if (answer.evaluation){
					var evaluation = WritingSelectors.evaluation({state, id: answer.evaluation})
					if (evaluation.autograder_data && evaluation.autograder_data.warning && evaluation.autograder_data.warning.length > 0){
						return true
					}
				}
				else return false
			})
		}
		
		return downProps;
	},

	(dispatch, props) => ({
		onUpdate: (evaluationID, evaluationUpdate) => {
			if (evaluationID) {
				dispatch(WritingActions.updateEvaluation({ id: evaluationID, update: evaluationUpdate }));
			}
		},
	})
)
class ScoreDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		if (props.evaluation && props.evaluation.ratio) {
			var editedScore = this.hideAutograderScore(props.evaluation) ? 0 : $wr.convertedScore(props.evaluation.ratio, props.displayScoreCap || 4);
		}

		this.state = { editedScore };

	}

	displayScoreCap(props) {
		return (props || this.props).displayScoreCap || 4;
	}

	isPassing() {
		var ratio = this.props.evaluation.ratio
		var threshold = this.props.passingThreshold
		return ratio >= threshold;
	}

	hideAutograderScore(evaluation) {
		evaluation = evaluation ? evaluation : this.props.evaluation
		return evaluation && !CurrentUser.isPremiumOrTrialAccount() && !evaluation.admin_score
	}

	isPending() {		
		return !this.props.evaluation || this.props.evaluation.score_cap === 0;
	}

	noCertainty() {
		return this.props.evaluation.certainty === 0;
	}

	// saves evaluation score
	saveEvaluation() {
		var originalEvaluation = this.props.evaluation;

		// Round up to the nearest 0.5
		var override = Math.round(this.state.editedScore * 2) / 2;

		var adminRatio = override / this.displayScoreCap();

		// Project this onto the scale of the original evaluation
		var adminScore = Math.ceil(adminRatio * originalEvaluation.score_cap);

		// set to 0 or score_cap if outside of 0-score_cap range
		if (adminScore < 0) {
			adminScore = 0;
			adminRatio = 0;
		} else if (adminScore > originalEvaluation.score_cap) {
			adminScore = originalEvaluation.score_cap;
			adminRatio = 1;
		}


		var scoreDetails = _.extend({}, originalEvaluation.score_details,
			{ admin_score: adminScore });

		// Included both score (for immediate display) and adminScore (for the API Patch)
		var updateData = {
			score: adminScore, ratio: adminRatio, admin_score: adminScore,
			score_details: scoreDetails
		}

		this.props.onUpdate(originalEvaluation.id, updateData);
		this.setState({ editingEvaluation: false, showOverrideFeedback: true });

		window.wrNotifications.triggerDropDownNotification({
			title: "Score Edited",
			text: "You have edited the score for this " + this.props.noun + ".",
			icon: "ok-sign"
		});

	}

	// shows save button if admin has edited score or rubric item
	renderSaveButton() {
		return <button onClick={this.saveEvaluation} className="btn btn-link saveButton">Save</button>
	}

	render() {
		var evaluation = this.props.evaluation;

		var className = "scoreDisplay";
		var tooltipText = undefined;
		
		var flagAlert
		if (this.props.evaluation && CurrentUser.isPremiumOrTrialAccount()){
			if (this.props.filters || this.props.evaluation.filtered && !this.props.asStudent){
				flagAlert = (
					<div className="scoringFlags">
						<Glyphicon className="filterIcon" icon="flag" dataTip="Some answers don't seem quite right"/>
					</div>
				)
			}
			else if (this.props.warnings && !this.props.asStudent) {
				flagAlert = (
					<div className="scoringFlags">
						<Glyphicon className="warningIcon" icon="flag" dataTip="Some answers don't seem quite right"/>
					</div>
				)
			}
	
			else {flagAlert = ""}
		}

		if (this.hideAutograderScore()) {
			className += " noAdminScore";
			if (CurrentUser.isStudent()) {
				tooltipText = "Hang tight! Your teacher will grade this item shortly.";
				var mainContent = (
					<span>
						<Glyphicon icon="question-sign" dataTip={tooltipText} />
						<ReactTooltip effect="solid" />
					</span>
				);
			} else {
				className += " adminScoreForm";
				if (this.state.editedScore) {
					className += " saveShowing";
					var saveButton = this.renderSaveButton()
				}
				var tip = 'This item has not been graded'
				var mainContent = (
					<div>
						<Glyphicon icon="exclamation-sign" className='warningIcon' dataTip={tip} />
						<NumbersOnlyInput className="form-control scoreInput" allowDecimal
							value={this.state.editedScore} step={0.5}
							onChange={(e) => this.setState({ editedScore: parseFloat(e.target.value) })}
							max={this.displayScoreCap()} min={0} />
						<div className="scoreCap">/ {this.displayScoreCap()}</div>
						{saveButton}
					</div>
				);
			}
		} else if (this.isPending()) {
			tooltipText = "Pending. This " + this.props.noun + " will be graded within 24 hours.";
			var mainContent = (
				<span data-tip={tooltipText} data-for="hourglassDataTip">
					<Glyphicon icon="hourglass" />
					<ReactTooltip id={`hourglassDataTip`} />
				</span>
			);

		} else if (this.noCertainty()) {
			tooltipText = "Unable to score. Quizzes for less common books will not be graded unless they include open-ended questions.";
			var mainContent = (
				<Glyphicon icon="minus" dataTip={tooltipText} />
			);

		} else {
			var convertedScore = $wr.convertedScore(this.props.evaluation.ratio, this.props.displayScoreCap || 4);
			if (this.props.showDenominator) {
				var denominator = (
					<span className="denominator"> / { this.displayScoreCap() }</span>
				)
			};

			var mainContent = (
				<span>
					{ convertedScore }{ denominator }
				</span>
			);
		}
		
		if (this.props.mode == CIRCLE_MODE) {
			className += " circleMode";
			if (this.isPending() || this.noCertainty() || this.hideAutograderScore()) {
				className += " neutralDisplay";
			} else if (this.isPassing()) {
				className += " passDisplay";
			} else {
				className += " failDisplay";
			}

			if (this.props.excluded) {
				className += " excludedStripes";

				if (this.props.asStudent) {
					tooltipText = "This " + this.props.noun + " will not count toward the goals your teacher set.";
				} else {
					tooltipText = "This " + this.props.noun + " will not count toward your custom goals.";
				}
			}

		} else if (this.props.mode == INLINE_MODE) {
			if (convertedScore !== undefined && !this.isPending()) {
				var passText = this.isPassing() ? "Pass: " : "Fail: ";
			}
			className += " inlineMode";
		} else if (this.props.mode == SCORE_ONLY_MODE) {
			if (!this.isPending()) {
				className += this.isPassing() ? " passed" : " failed"
			}
			className += " scoreOnlyMode";
		}

		// have to render circle + inline modes separately, because of complications from css 
		// + rendering warning flags.
		if (this.props.mode == CIRCLE_MODE && CurrentUser.isPremiumOrTrialAccount()){
			return (
			<div className="scoreContainer">
				<div className={className}>
					{ passText }
					{ mainContent }
				</div>
				<div className="flagContainer">
					{ flagAlert }
				</div>
			</div>)
		}
		
		else {
			if (flagAlert){
				className += " withFlag inlineFlagContainer"
			}
			else {
				className += " noFlag"
			}

			return (
				<div className={ className }>
					{ passText }
					{ mainContent }
					{ flagAlert }
				</div>
			)
		}
		
	}
};

var CIRCLE_MODE = "circle";
var INLINE_MODE = "inline";
var SCORE_ONLY_MODE = "score_only";

ScoreDisplay.CIRCLE_MODE = CIRCLE_MODE;
ScoreDisplay.INLINE_MODE = INLINE_MODE;
ScoreDisplay.SCORE_ONLY_MODE = SCORE_ONLY_MODE;

ScoreDisplay.propTypes = StrictPropTypes({
	subjectID: PropTypes.number,
	subjectType: PropTypes.string,
	evaluationID: PropTypes.number,
	mode: PropTypes.string,
	showDenominator: PropTypes.bool,
	answerIDs: PropTypes.array,
	// From @connect
	evaluation: PropTypes.object,
	passingThreshold: PropTypes.number,
	displayScoreCap: PropTypes.number,
	noun: PropTypes.string,
	excluded: PropTypes.bool,
	asStudent: PropTypes.bool,
	changeLocationState: PropTypes.func,
	onUpdate: PropTypes.func
});

module.exports = ScoreDisplay;



// WEBPACK FOOTER //
// ./modules/components/writing/evaluations/ScoreDisplay.js